<template>
  <div>
    <v-card class="pa-5 mb-5">
      <v-row align="center" justify="center">
        <v-col>
          <h3>Histórico de {{ !problem ? 'Mensagens' : 'Ocorrências' }}</h3>
        </v-col>
        <v-col class="text-right">
          <TheButton
            :text="!problem ? 'Novo Tópico' : 'Nova Ocorrência'"
            icon="mdi-message-plus-outline"
            color="green"
            @click="dialog = true"
          />
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col>
        <v-card class="pa-5 fill-height">
          <h3>Tópicos</h3>
          <v-divider></v-divider>
          <div v-for="(item, i) in topics" :key="i">
            <v-card
              :color="item.topicId === selectedTopic.topicId ? 'blue-grey lighten-1' : 'blue-grey lighten-5'"
              flat
              class="caption my-2 pa-2 rounded-lg"
              @click="viewTopic(item)"
            >
              <v-row no-glutters align="center">
                <v-col> {{ item.orderIdMarketplace }} - {{ item.topicSubject }} </v-col>
                <v-col cols="3" class="text-right">
                  <v-btn depressed  dark x-small color="red darken-1"  v-if="item.topicStatus === 2">
                    <v-icon small>mdi-lock-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
          <div v-if="topics.length === 0" class="caption py-5">
            <i>Nenhum tópico Localizado</i>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="messages.length > 0" cols="8">
        <v-card border="bottom" color="indigo darken-1" class="rounded-lg pa-5 mb-5" dark>
          Mensagens do Tópico
        </v-card>
        <div class="fill-height">
          <TheMessage :message="item" :index="i" v-for="(item, i) in messages" :key="i" class="mb-5" />
          <v-card class="pa-5" v-if="selectedTopic.topicStatus === 1">
            <vue-editor v-model="message" />
            <v-btn color="primary" class="mt-3" depressed dark @click="save()">
              <v-icon class="mr-1">mdi-message-plus-outline</v-icon>
              Responder
            </v-btn>
            <v-btn
              color="red darken-1"
              class="ml-3 mt-3"
              depressed
              dark
              @click="changeTopicStatus(2)"
              v-if="selectedTopic.topicStatus === 1"
            >
              <v-icon x-small>mdi-lock-outline</v-icon>
              Fechar Tópico
            </v-btn>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <TheDialog icon="mdi-message" title="Mensagens" v-model="dialog" width="600px">
      <template>
        <b>Assunto</b>
        <v-text-field
          hide-details
          label="Título"
          outlined
          dense
          v-model="newTopic.subject"
          class="mb-2"
          v-if="!problem"
        ></v-text-field>
        <v-select
          hide-details
          label="Título"
          outlined
          dense
          v-model="newTopic.subject"
          class="mb-2"
          v-if="problem"
          :items="problems"
        ></v-select>
        <b>Mensagem</b>
        <vue-editor v-model="newTopic.message" />
      </template>
      <template v-slot:actions>
        <v-btn color="blue-grey darken-2" depressed dark @click="saveNewTopic()">
          <v-icon class="mr-1">mdi-message-plus-outline</v-icon>
          Criar {{ !problem ? 'Novo Tópico' : 'Nova Ocorrência' }}
        </v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

import TheDialog from '@/components/TheDialog'
import TheMessage from '@/components/TheMessage'
import TheButton from '@/components/TheButton'
import { VueEditor } from 'vue2-editor'

export default {
  props: {
    orderIdMarketplace: String,
    problem: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    messages: [],
    message: null,
    topics: [],
    messageAnswer: '',
    loading: false,
    dialog: false,
    newTopic: {},
    problems: ['NF cancelada (ruptura de estoque)', 'Devolução (arrependimento)', 'Devolução (sinistro)', 'Chargeback'],
    selectedTopic: null,
  }),
  components: {
    TheButton,
    TheDialog,
    VueEditor,
    TheMessage,
  },
  methods: {
    viewTopic(topic) {
      this.loading = true
      this.newTopicFlag = false
      const url = `${baseApiUrl}/topic/${topic.topicId}`
      this.selectedTopic = topic
      axios
        .get(url)
        .then((res) => {
          this.messages = res.data
          this.messageAnswer = ''
          this.loading = false
        })
        .catch(showError)
    },
    loadTopicsByOrderId(topic = null) {
      this.messages = []
      this.loading = true
      let url = `${baseApiUrl}/order/${this.orderIdMarketplace}/topic`
      if (this.problem) {
        url = `${baseApiUrl}/order/${this.orderIdMarketplace}/problems`
      }
      axios
        .get(url)
        .then((res) => {
          if (topic) {
            this.selectedTopic = topic
          } else {
            this.selectedTopic = res.data[0]
          }
          this.topics = res.data
          this.messageAnswer = ''
          this.loading = false
          this.$emit('input', this.topics.length)
        })
        .catch(showError)
    },
    save() {
      this.loading = true
      if (!this.message) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'É preciso inserir uma mensagem válida.',
          button: 'Ok!',
        })
        return false
      }
      const url = `${baseApiUrl}/topic/${this.selectedTopic.topicId}`
      const body = {
        message: this.message,
      }
      axios
        .post(url, body)
        .then(() => {
          this.viewTopic(this.selectedTopic)
          this.message = ''
        })
        .catch(showError)
    },
    saveNewTopic() {
      if (!this.newTopic.subject || !this.newTopic.message) {
        this.$store.dispatch('setErrorInfo', {
          open: true,
          text: 'É preciso inserir uma mensagem válida.',
          button: 'Ok!',
        })
        return false
      }

      this.loading = true
      const url = `${baseApiUrl}/topic`
      const body = {
        topicSubject: this.newTopic.subject,
        orderIdMarketplace: this.orderIdMarketplace,
        message: this.newTopic.message,
      }
      if (this.problem) {
        body.type = 1
      }

      axios
        .post(url, body)
        .then((res) => {
          this.newTopic = {}
          this.dialog = false
          // this.loadTopicsByOrderId()
          this.loadTopicsByOrderId({
            topicId: res.data[0],
          })
        })
        .catch(showError)
    },
    changeTopicStatus(status) {
      const url = `${baseApiUrl}/topic/${this.selectedTopic.topicId}`
      const body = { status: status }
      axios
        .put(url, body)
        .then(() => {
          this.loadTopicsByOrderId()
        })
        .catch(showError)
    },
  },
  created() {
    this.loadTopicsByOrderId()
  },
  watch: {
    topics() {
      if (this.topics.length > 0) {
        this.viewTopic(this.selectedTopic)
      }
    },
    problem() {
      this.loadTopicsByOrderId()
    },
  },
}
</script>

<style></style>
